<div class="page-header">
    <div class="col-12">
        <h1>Projected Hours Remaining <small>View and update projected hours by project by phase</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="active" class="nav-tabs">
        <li [ngbNavItem]="1">
            <a ngbNavLink>Records</a>
        </li>
        <li [ngbNavItem]="2">
            <a ngbNavLink>Projected Chart</a>
        </li>
        <li [ngbNavItem]="3">
            <a ngbNavLink>Department Chart</a>
        </li>
    </ul>

    <div style="margin-top: 20px" [hidden]="active !== 1">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                    <grid-export [grid]="mainGrid" [name]="'Projected Hours'" [hidden]="active !== 1"></grid-export>

                    <div class="input-header-group">
                        <span class="input-header">Quarters To Show</span>
                        <wj-input-number
                            id="quatersToShow"
                            style="width: 110px"
                            [isRequired]="true"
                            [format]="'n0'"
                            [step]="1"
                            [max]="16"
                            [min]="1"
                            [(value)]="quartersToShow"
                        ></wj-input-number>
                    </div>

                    <div class="input-header-group">
                        <span class="input-header">Active Jobs</span>
                        <wj-multi-select
                            style="width: 300px"
                            [itemsSource]="activeJobsList"
                            [placeholder]="'Choose Jobs'"
                            [selectedValuePath]="'value'"
                            [displayMemberPath]="'display'"
                            [checkedMemberPath]="'selected'"
                            [showSelectAllCheckbox]="true"
                            [showFilterInput]="true"
                            [maxHeaderItems]="1"
                            (checkedItemsChanged)="resetColumns()"
                        ></wj-multi-select>
                    </div>

                    <div class="input-header-group">
                        <span class="input-header">Show 0 Hours Remaining</span>
                        <wj-combo-box
                            id="isActive"
                            style="width: 150px"
                            [(ngModel)]="showZeroHoursRemaining"
                            name="isActive"
                            [itemsSource]="boolList"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>

                    <span style="padding-top: 4px"
                        ><b>{{ openMonth | date: 'MMM yyyy' }}</b> is the open month. 'Project Hours Remaining' is calculated prior to this
                        month.</span
                    >
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="mainGrid"
                    #mainGrid
                    appAutoSize
                    [padding]="73"
                    (initialized)="grid.initialize(mainGrid)"
                    [itemsSource]="grid.view"
                    [keyActionTab]="'MoveAcross'"
                    [itemFormatter]="mainGridItemFormatter"
                    (cellEditEnding)="cellEditEnding(mainGrid, $event)"
                    (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Job'" [binding]="'jobDisplay'" [width]="375" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Phase'"
                        [binding]="'phaseDisplay'"
                        [width]="375"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Phase Master'"
                        [binding]="'phaseMasterName'"
                        [width]="0"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'PR Dept'"
                        [binding]="'departmentName'"
                        [width]="250"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>

                    <wj-flex-grid-column
                        [header]="'Actual Hours'"
                        [binding]="'actualHours'"
                        [width]="85"
                        [isReadOnly]="true"
                        [format]="'N1'"
                        [aggregate]="'Sum'"
                    ></wj-flex-grid-column>

                    <wj-flex-grid-column
                        [header]="'Progress % Complete'"
                        [binding]="'progressPercentComplete'"
                        [width]="110"
                        [isReadOnly]="true"
                        [format]="'P0'"
                        [dataType]="'Number'"
                    ></wj-flex-grid-column>

                    <wj-flex-grid-column
                        [header]="'Current Estimated Hours'"
                        [binding]="'currentEstHrs'"
                        [width]="110"
                        [isReadOnly]="true"
                        [format]="'N1'"
                        [aggregate]="'Sum'"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Projected Hours Remaining'"
                        [binding]="'remainingHours'"
                        [width]="110"
                        [isReadOnly]="true"
                        [format]="'N1'"
                        [aggregate]="'Sum'"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Projected Hours Allocated'"
                        [binding]="'totalHoursProjected'"
                        [width]="130"
                        [isReadOnly]="true"
                        [format]="'N1'"
                        [aggregate]="'Sum'"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Projected Hours Unallocated'"
                        [binding]="'variance'"
                        [width]="120"
                        [isReadOnly]="true"
                        [format]="'N1'"
                        [aggregate]="'Sum'"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Workoff Start'"
                        [binding]="'startDate'"
                        [width]="100"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Workoff Comp'"
                        [binding]="'endDate'"
                        [width]="100"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    @for (col of quartersCols; track col.binding) {
                        <wj-flex-grid-column
                            [binding]="col.binding"
                            [format]="'N1'"
                            [align]="'right'"
                            [header]="col.header"
                            [aggregate]="'Sum'"
                            [width]="col.width"
                            [isReadOnly]="col.isReadOnly"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                    }
                </wj-flex-grid>
                <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
            </div>
        </div>
    </div>
    <div style="margin-top: 20px" [hidden]="active !== 2">
        <app-projected-hours-chart [activeJobsList]="activeJobsList" [active]="active"> </app-projected-hours-chart>
    </div>
    <div style="margin-top: 20px" [hidden]="active !== 3">
        <app-department-chart [active]="active" [departments]="departments()"> </app-department-chart>
    </div>
</div>
